import { VideoObservation } from "../main/components/videos/enums/VideoObservation";
import { IVideoEntry } from "../main/components/videos/models/IVideoEntry";
import { ColourService } from "./colour.service";
import { TranslationService } from "./translation.service";

export interface IObservationCategory {
    label: string;
    translation?: string;
    count?: number;

    observation: VideoObservation;
}

export class ObservationsService {
    static $inject = ["colourService", "translationService"];

    constructor(
        private readonly colourService: ColourService,
        private readonly translationService: TranslationService
    ) {
    }

    getObservations(eventsToGetObservationsBy?: IVideoEntry[]): IObservationCategory[] {
        if (!eventsToGetObservationsBy) {
            eventsToGetObservationsBy = [];
        }

        let i = 100;
        let observationsToReturn: IObservationCategory[] = [];

        for (let observation in VideoObservation) {
            if (!isNaN(Number(observation))) {
                continue;
            }

            var observationEnum: VideoObservation = VideoObservation[observation] as any;

            observationsToReturn.push({
                label: observation,
                translation: this.translationService.tEnum(VideoObservation, "VideoObservation", observationEnum),
                count: 0,
                observation: observationEnum
            });
        }

        const observationsToFilter = this.createAvailableObservationsToFilterBy(eventsToGetObservationsBy);

        observationsToReturn.forEach(obs => {
            obs.count = observationsToFilter.filter(obsToFilter => obsToFilter == obs.label).length;
        });

        observationsToReturn.sort((o1, o2) => o1.label.localeCompare(o2.label));

        return observationsToReturn;
    }

    getObservationsColour(index: number) {
        return this.colourService.getVigetColor(index, Object.keys(VideoObservation).length, 2);
    }

    setObservationTitleForDisplay(observation: VideoObservation): string {
        return this.translationService.t(`VideoObservationEnum.${VideoObservation[observation]}`);
    }

    //------

    private createAvailableObservationsToFilterBy(videoEvents: IVideoEntry[]): string[] {
        const observations: string[] = [];

        videoEvents.forEach(videoEvent => {
            if (videoEvent.MetaData?.VideoObservations) {
                videoEvent.MetaData?.VideoObservations.forEach(vc => {
                    if (!observations.find(obs => obs == VideoObservation[vc])) {
                        observations.push(VideoObservation[vc]);
                    }
                });
            }
        });

        return observations;
    }
}
